export default class FilterBookingRoleStatisticsRequest {
    startAtFrom: string;
    branchId: string;
    deskId: string;
    companyId: string;
    locationId: string;
}